// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_array = require("rescript/lib/js/js_array.js");
var ApolloHooks = require("reason-apollo-hooks/src/ApolloHooks.bs.js");
var ReasonPromise = require("../ReasonPromise.bs.js");
var Utils__Promise = require("../../utils/Utils__Promise.bs.js");

var ppx_printed_query = "fragment EmailRegistrationStatusResult on EmailRegistrationStatusResult   {\nemail  \nstatus  \n}\n";

function parse(value) {
  var value$1 = Js_json.decodeObject(value);
  if (value$1 === undefined) {
    return Js_exn.raiseError("Unexpected GraphQL query response");
  }
  var value$2 = Js_dict.get(value$1, "email");
  var field_email = value$2 !== undefined ? value$2 : Js_exn.raiseError("Unexpected GraphQL query response");
  var value$3 = Js_dict.get(value$1, "status");
  var field_status = value$3 !== undefined ? (
      value$3 === "AVAILABLE" ? "AVAILABLE" : "REGISTERED"
    ) : Js_exn.raiseError("Unexpected GraphQL query response");
  return {
          email: field_email,
          status: field_status
        };
}

var name = "EmailRegistrationStatusResult";

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var EmailRegistrationStatusResult = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: name,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var EmailRegistrationStatusResult$1 = {
  EmailRegistrationStatusResult: EmailRegistrationStatusResult,
  Fragment: undefined
};

var ppx_printed_query$1 = "query emailRegistrationStatus($email: String!)  {\nemailRegistrationStatus(email: $email)  {\n...EmailRegistrationStatusResult   \n}\n\n}\nfragment EmailRegistrationStatusResult on EmailRegistrationStatusResult   {\nemail  \nstatus  \n}\n";

function parse$1(value) {
  var value$1 = value["emailRegistrationStatus"];
  return {
          emailRegistrationStatus: !(value$1 == null) ? parse(value$1) : undefined
        };
}

function make(email, param) {
  return {
          query: ppx_printed_query$1,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], "Null");
                    }), [[
                      "email",
                      email
                    ]])),
          parse: parse$1
        };
}

function makeWithVariables(variables) {
  var email = variables.email;
  return {
          query: ppx_printed_query$1,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], "Null");
                    }), [[
                      "email",
                      email
                    ]])),
          parse: parse$1
        };
}

function makeVariables(email, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], "Null");
                  }), [[
                    "email",
                    email
                  ]]));
}

function definition_2(graphql_ppx_use_json_variables_fn, email, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], "Null");
                      }), [[
                        "email",
                        email
                      ]])));
}

var definition = [
  parse$1,
  ppx_printed_query$1,
  definition_2
];

function ret_type$1(f) {
  return {};
}

var MT_Ret$1 = {};

var Query = {
  ppx_printed_query: ppx_printed_query$1,
  query: ppx_printed_query$1,
  parse: parse$1,
  make: make,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type$1,
  MT_Ret: MT_Ret$1
};

function useEmailRegistrationStatusQuery(param) {
  var match = ApolloHooks.useQuery(undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, definition);
  var query = match[1];
  return function (email) {
    return ReasonPromise.map(Utils__Promise.fromJsPromise(Curry._2(query.refetch, makeVariables(email, undefined), undefined)), (function (x) {
                  if (x.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: "NETWORK_ERROR"
                          };
                  }
                  var emailRegistrationStatus = x._0.emailRegistrationStatus;
                  if (emailRegistrationStatus !== undefined) {
                    return {
                            TAG: "Ok",
                            _0: emailRegistrationStatus
                          };
                  } else {
                    return {
                            TAG: "Error",
                            _0: "NO_DATA"
                          };
                  }
                }));
  };
}

exports.EmailRegistrationStatusResult = EmailRegistrationStatusResult$1;
exports.Query = Query;
exports.useEmailRegistrationStatusQuery = useEmailRegistrationStatusQuery;
/* ApolloHooks Not a pure module */
